const header = {
    title: 'CK',
}

const about = {
    name: 'Chandan Kumar',
    description: ' Driven by a passion for technology, I eagerly explore the vast landscape of web development. With a thirst for knowledge, I am dedicated to mastering the skills needed to build dynamic and innovative applications.',
    resume: 'https://example.com',
    social: {
        linkedin: 'https://www.linkedin.com/in/chandan-kumar-2b855224b/',
        github: 'https://github.com/chandankumarm55',
        leetcode: 'https://leetcode.com/u/chandanchand769/'
    },
}

const projects = [{
        name: 'X-Change',
        description: 'This exchange app fosters real-time chats among all users, enhancing connectivity and fostering seamless interactions across the platform',
        stack: ['Styled', 'JavaScript', 'React', 'Socket-io'],
        sourceCode: 'https://github.com/chandankumarm55/Xchange-Frontend',
        livePreview: 'https://x-change-chatapplication.netlify.app/',
    },
    {
        name: 'Blog Application',
        description: 'blog app enables users to create, delete, update, and fetch their blogs. Simple yet effective for seamless blogging experience',
        stack: ['Css', 'JavaScript', 'React', 'express', 'mutter'],
        sourceCode: 'https://github.com/chandankumarm55/Blog-React-Frontend',
        livePreview: 'https://blog-react-chandan.netlify.app',
    },
    {
        name: 'Evolve AI',
        description: 'Evolve SI is a versatile platform for conversation, image generation, text-to-speech translations, object deduction, and even joke generation. Experience innovation seamlessly',
        stack: ['Cleark', 'JavaScript', 'Rapid-APi', 'Bootstrap'],
        sourceCode: 'https://github.com/chandankumarm55/Evolve-ai',
        livePreview: 'https://evolve-ai-chanadan.netlify.app',
    },
]

const skills = []

const contact = {
    email: 'chandanchand769@gmail.com',
}

const certificates = {
    description: "Below are the certificates I have earned. You can download the PDF file containing all certificates.",
    pdfLink: './academics-certifactes.pdf'
}

export { header, about, projects, skills, contact, certificates }